<section id="description" *transloco="let t; prefix: 'property-details.property-descriotion-section'">
  @if (model) {
  <div class="flex md:flex-row flex-col md:mb-2 mb-4 md:items-center justify-between">
    <h1 class="rfs:text-4xl font-semibold text-black md:mb-0 mb-[.625rem]">{{ model.title }}</h1>
    <div class="flex flex-row items-center gap-4">
      <!-- <span
        *ngIf="model.previousPrice"
        class="text-semibold text-2xl line-through text-gray-700"
        >{{ model.previousPrice | currency: "EUR" : 'symbol' : '1.0-0' }}</span
      > -->
      <span class="rfs:text-4xl font-semibold text-black">{{ model.price | currency: "EUR" : 'symbol' : '1.0-0' }}</span>
    </div>
  </div>
  <div class="grid md:grid-cols-2 justify-between mb-6">
    <span class="flex flex-col md:flex-row md:items-center md:mb-0 mb-4">
      <span class="text-gray-900 pr-4 md:mb-0 mb-3 border-r border-300">
        {{ model.address ? model.address.prefecture : "" }}
      </span>
      <span class="text-gray-900 pr-4 md:pl-4 md:border-r border-300">
        ID: {{ model.code }}
      </span>
    </span>
    <span *ngIf="model.auctionRound" class="flex flex-row items-center gap-2 md:justify-end">
      {{ t("auctionDateText") }}: <span class="text-[#3B61C1] font-semibold">{{ auctionDateFormatted | date:'dd/MM/yy'
        }}</span>
    </span>
  </div>
  <div class="flex flex-col-reverse items-start gap-6 lg:flex-row lg:items-center lg:justify-between mb-12">
    <div class="flex flex-row lg:gap-y-0 gap-y-5 lg:gap-x-0 gap-x-6 lg:w-auto w-full items-center">
      <span class="text-gray-900 lg:pr-4 lg:border-r border-300 flex flex-row items-center gap-2">
        <i class="icon-needs-renovation"></i>
        {{ model.constructionYear ?? "-" }}
      </span>
      <span *ngIf="model.floor" class="text-gray-900 lg:px-4 lg:border-r border-300 flex flex-row items-center gap-2">
        <i class="icon-stairs"></i>
        {{ model.floor }}{{ t("floor") }}
      </span>
      <span class="text-gray-900 lg:px-4 lg:border-r border-300 flex flex-row items-center gap-2">
        <i class="icon-bed"></i>
        {{ model.numberOfRooms }} {{ t("rooms") }}
      </span>
      <span class="text-gray-900 lg:pl-4 flex flex-row items-center gap-2">
        <i class="icon-bathroom"></i>
        {{ model.numberOfBathrooms }} {{ t("bathrooms") }}
      </span>
    </div>
    <div class="flex items-center gap-3">
      <button *ngIf="!this.model.isSold" (click)="toggleFavorite($event)" class="btn-icon-secondary-sm">
        <i [ngClass]="
            model.isFavorite
              ? 'icon-heart-filled text-primary'
              : 'icon-heart-line'
          "></i>
      </button>
      <button id="shareButton" appShare [shareTitle]="model.title" [shareText]="buildShareText" [shareUrl]="shareUrl"
        type="button" class="btn-icon-secondary-sm">
        <i class="icon-share-alt"></i>
      </button>
    </div>
  </div>
  <div *ngIf="model.preApproved === 'Approved'" class="bg-[#037079CC] text-white p-4 rounded-[8px] mb-12">
    <button (click)="toggleAccordionApproved()" type="button"
      class="rotate-0 transition-all flex flex-row-reverse items-center justify-between w-full gap-8"
      [ngClass]="{ 'mb-4': accordionApproved }">
      <div class="rotate-0 transition-all text-end self-start" [ngClass]="{ 'rotate-180': accordionApproved }">
        <i class="icon-chevron-up"></i>
      </div>
      <div class="flex flex-col gap-4 md:flex-row md:justify-between w-full text-start">
        <div class="font-semibold">{{ t("nbg-approved") }}</div>
        <div class="flex flex-row items-center gap-8">
          <img style="height: 18px" src="{{'assets/svgs/nbg-logo' + (activeLanguage === 'el' ? '-white' : '') +'.svg'}}"
            alt="NBG Logo" />
        </div>
      </div>
    </button>
    <div class="text-white overflow-hidden" [ngClass]="{ 'h-0': !accordionApproved }">
      {{ this.preapprovalDescr }}
    </div>
    <div class="mt-6" [ngClass]="{ 'hidden': !accordionApproved }">
      <a type="button" class="text-primary-300" [ngClass]="{ 'hidden': !accordionApproved }" target="_blank"
        [localizedRouterLink]="'/services/preapproval'">
        {{t('nbg-approved-learnMore')}} <i class="icon-plus"></i></a>
    </div>
  </div>

  <div class="font-semibold text-black text-2xl mb-6">
    {{ model.shortDescription }}
  </div>
  <div class="relative overflow-hidden mb-6" [ngClass]="{ 'max-h-[168px] overflow-hidden': !descriptionOpen }">
    {{ model.description }}
    @if (!descriptionOpen) {
    <div role="button" (click)="toggleDescription()" class="blur-cascade"></div>
    }
  </div>
  <button type="button" (click)="toggleDescription()" class="btn-text">
    {{ descriptionOpen ? t("show-less") : t("show-more") }}
  </button>
  }
</section>
